import jwtDecode from 'jwt-decode';

/** @ignore */
export function injectImpersonatorHelper($rootScope, ImpersonatorHelper) {
	'ngInject';
	// on every ui-router state change, check for a jwt
	$rootScope.$on('$stateChangeStart', () => {
		// const route = toState.url;
		ImpersonatorHelper.setJwt();
	});
}
export class ImpersonatorHelperService {
	constructor($rootScope) {
		'ngInject';
		this.$rootScope = $rootScope;
	}

	setJwt() {
		if (window.IS_LOCAL_INSTALL) {
			const searchParams = new URLSearchParams(window.location.search);
			const jwt = searchParams.get('jwt');

			// clear out the jwt from the url so if we change hubs we can actually change hubs
			// w/o this you will just keep ending up in the same hub
			// the '#' is included in window.location.hash see https://developer.mozilla.org/en-US/docs/Web/API/Location/hash
			window.location.replace(`${window.BASE_URL}/hub${window.location.hash}`);

			if (jwt) {
				try {
					const payload = jwtDecode(jwt);
					localStorage.setItem('jwt', JSON.stringify({ payload, token: jwt }));
				} catch (e) {
					console.error('jwt decode error', e);
				}
			}
		}
	}
}
